<template>
    <VContent>
        <VContainer fill-height>
            <VLayout
                    style="{max-width:500px;}"
                    align-content-center
                    mx-auto
                    wrap
            >
                <VFlex xs12 sm8 offset-sm2 md5 offset-md4 >
                    <BaseCard>
                        <VCardTitle>
                            <span class="headline">
                                Sign Up - Beta!
                            </span>
                        </VCardTitle>
                        <VCardText
                                pa-0
                                grid-list-xl
                        >
                            <VLayout>
                                <VFlex xs12>
                                    <VForm
                                            ref="form"
                                            v-model="form"
                                            class="mb-5"
                                            lazy-validation
                                    >
                                        <VContainer pa-0>
                                            <VLayout wrap>
                                                <VFlex xs12>
                                                    <!--<VTextField-->
                                                        <!--v-model="email"-->
                                                        <!--:rules="[rules.required('Enter your email address')]"-->
                                                        <!--label="Email"-->
                                                        <!--name="email"-->
                                                        <!--email-->
                                                        <!--outlined-->
                                                    <!--/>-->
                                                </VFlex>
                                                <VFlex xs12>
                                                    <VTextField
                                                        v-model="email"
                                                        :rules="[$store.state.rules.required,$store.state.rules.emailRules]"
                                                        label="Email"
                                                        hint="Must be valid email"
                                                        name="email"
                                                        outlined
                                                    />
                                                </VFlex>
                                                <VFlex xs12>
                                                    <VTextField
                                                        v-model="password"
                                                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                        :rules="[$store.state.rules.required]"
                                                        :type="show ? 'text' : 'password'"
                                                        hint="Must contain at least one number, one capital and one lowercase letter"
                                                        label="Password"
                                                        persistant-hint
                                                        outlined
                                                        @click:append="show = !show"
                                                    />
                                                </VFlex>
                                                <VFlex xs12 class="mt-2">
                                                    <BaseBtn
                                                            :disabled="!form"
                                                            :loading="isLoading"
                                                            prominent
                                                            block large
                                                            @click="submit"
                                                    >
                                                        Sign Up
                                                    </BaseBtn>
                                                </VFlex>
                                            </VLayout>
                                        </VContainer>
                                    </VForm>
                                </VFlex>
                            </VLayout>

                            <VLayout wrap>
                                <VFlex xs12>
                                    <p class="text-center pa-2" >
                                        By signing up, you agree to our Terms , Data Policy and Cookies Policy .
                                    </p>
                                </VFlex>
                                <VFlex xs12>
                                    <p class="text-center my-2 pa-4" >
                                        Have an account?
                                        <BaseBtn text  to="/auth/signin">
                                            Sign In
                                        </BaseBtn>
                                    </p>
                                </VFlex>
                            </VLayout>

                        </VCardText>

                    </BaseCard>
                </VFlex>
            </VLayout>
        </VContainer>
    </VContent>
</template>

<script>
  // Utilities
  import {
    mapActions,
    mapMutations
  } from 'vuex'

  export default {
    data () {
      const data = {
        isLoading: false,
        form: false,
        form2:false,
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        username: undefined,
        password: undefined,
        confirmpassword: undefined,
        code: undefined,
        rules: {
          required: msg => v => !!v || msg,
          confirm: v => v ? v === this.password : 'Passwords do not match'
        },
        show: false,
        showConfirm: false
      }
      return data
    },
    // watch: {
    //   isReady (val) {
    //     console.log('is ready: ', val)
    //     console.log('logged in', this.isLoggedIn)
    //     if (val && this.isLoggedIn) {
    //       let em = this
    //       setTimeout(function () {
    //         em.$router.push('/authenticated')
    //       }, 200)
    //     }
    //   }
    // },
    mounted () {
      // let l = this.$store.getters['cognito/isLoggedIn'];
      // if(l && this.$route.path.includes('auth')){
      //   this.$router.push('/')
      // }
    },
    methods: {
      ...mapActions('cognito', ['registerUser']),
      ...mapMutations(['setSnackbar']),
      submit () {
        if (!this.$refs.form.validate()) return
        this.isLoading = true
        window.localStorage.setItem('username', this.email.trim())

        this.registerUser({
          username: this.email.toLowerCase().trim(), // this.username.trim(),
          password: this.password.trim(),
          attributes: {
            name: `first last`,
            email: this.email.toLowerCase().trim()
          }
        })
            .then((d) => {
            this.setSnackbar({
              type: 'success',
              msg: 'Account created. Check your email for verification'
            })

            this.$router.push('/auth/confirm')
          })
            .catch(err => {
              console.log(err)
            this.setSnackbar({
              type: 'error',
              msg: err.message,
              timeout: 10000
            })
          }).finally(() => (this.isLoading = false))

      }
    }
  }
</script>
